import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'api/models/QueryKeys';
import useGoogleStorageHelpers from 'utils/helpers/googleStorage.helpers';

export const useDownloadUrlFromGS = ({ storagePath }: { storagePath: string }) => {
  const { getDownloadUrlFromGS } = useGoogleStorageHelpers();

  const query = useQuery({
    queryKey: [QueryKeys.DownloadUrlFromGS, storagePath],
    queryFn: async () => getDownloadUrlFromGS(storagePath),
    enabled: Boolean(storagePath),
  });

  return {
    ...query,
    isLoading: query.isFetching, // the query is only enabled when params are available is defined so technically it's not loading
  };
};
